import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Canonicalizzazione dominio: forza la versione senza "www" così il frontend
// resta sulla stessa origine dell'API in produzione (evita chiamate cross-origin).
if (typeof window !== "undefined" && window.location.hostname.startsWith("www.")) {
  const url = new URL(window.location.href);
  url.hostname = url.hostname.replace(/^www\./, "");
  window.location.replace(url.toString());
}


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
